import { d as t, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as l, normalizeClass as n, normalizeStyle as r, createElementVNode as a } from "vue";
const c = t("screen-little"), i = /* @__PURE__ */ a("path", {
  d: "M257.471 275.98a56.884 56.884 0 1 1-59.785-96.702c89.82-55.632 179.639-110.923 269.515-166.555a85.325 85.325 0 0 1 89.649 0l269.458 166.441a56.884 56.884 0 1 1-59.785 96.76L511.969 118.81 257.47 275.98m0 472.133a56.884 56.884 0 1 0-59.785 96.703l269.515 166.441a85.325 85.325 0 0 0 89.649 0l269.458-166.441a56.884 56.884 0 1 0-59.785-96.703L511.969 905.17C427.099 852.837 342.285 800.39 257.414 748",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, u, h) {
  return s(), l("svg", {
    class: n(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const v = /* @__PURE__ */ o(c, [["render", m]]);
export {
  v as default
};
